class AnalyticsService {
  constructor () {
    this.measurementId = 'G-8SDYZZ1RYG'
  }

  // Track page views
  trackPageView (pageName, pagePath) {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', this.measurementId, {
        page_title: pageName,
        page_location: window.location.href,
        page_path: pagePath
      })
    }
  }

  // Track custom events
  trackEvent (eventName, parameters = {}) {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', eventName, parameters)
    }
  }

  // Track user interactions
  trackContentSubmission (contentType) {
    this.trackEvent('content_submission', {
      content_type: contentType
    })
  }

  trackVote (contentType, voteType) {
    this.trackEvent('vote', {
      content_type: contentType,
      vote_type: voteType
    })
  }

  trackUserLogin (method) {
    this.trackEvent('login', {
      method: method
    })
  }

  trackFavorite (contentType) {
    this.trackEvent('favorite', {
      content_type: contentType
    })
  }
}

export default new AnalyticsService()
